import { sha256 } from "yam-operator/util"
import { cacheGet, cacheSet } from "yam-operator/util/cache"
import { KV, OperateFunction } from "yam-types"
import { Settings } from "../settings.d"

const initImageRegistry: OperateFunction<unknown> = async (plan, _, settings: Settings) => {
  if (!settings.initImageRegistries) {
    return
  }
  const cacheKey = 'core-deploy-init-registry:' + plan.data.envName + '/' + plan.data.namespace
  const preHash = cacheGet(cacheKey)
  const hash = sha256(JSON.stringify(settings.initImageRegistries))
  if (preHash && preHash === hash) {
    return
  }

  plan.action(async (ctx) => {
    if (!settings.initImageRegistries) {
      return
    }
    for (const reg of settings.initImageRegistries) {
      plan.log.info(`initialize imagePullSecret '${reg.secretName}' for ${plan.data.envName} - ${plan.data.namespace}`)
      const auths = {} as KV
      reg.auths.forEach(regAuth => {
        if (!regAuth.auth || !regAuth.domain) {
          return
        }
        auths[regAuth.domain] = { auth: regAuth.auth }
      })
      await ctx.k8sClient.saveConf({
        name: reg.secretName,
        data: {
          '.dockerconfigjson': JSON.stringify({ auths })
        },
        secret: true,
        type: 'kubernetes.io/dockerconfigjson'
      })
    }
    if (!plan.data.dryRun) {
      cacheSet(cacheKey, hash)
    }
  }, `init-image-pull-secrets`)
}

export default initImageRegistry
